import { useContext } from 'react'
import { LayoutContext } from '../../context/layout-context'
import { queryClient } from '../../state'
import { CheckoutInfo } from '../../types'

export const useOrderMobile = () => {
  const {
    layoutState: { isOrderDetailsMobileShow },
  } = useContext(LayoutContext)

  const { payment_link: paymentLink } = queryClient.getQueryData([
    'checkout-info',
  ]) as CheckoutInfo

  return {
    order: paymentLink.additional_data.order,
    isOrderDetailsMobileShow,
  }
}
